module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "Viewer-"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "Viewer",
    class: {
      'Viewer--shiftHeader': _vm.shiftUiHeader,
      'Viewer--isFullScreen': _vm.screenfull.isFullscreen
    }
  }, [_c('div', {
    staticClass: "Viewer-container"
  }, [_c('transition', {
    attrs: {
      "name": "Viewer-ui-"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUi),
      expression: "showUi"
    }],
    staticClass: "Viewer-ui"
  }, [_c('div', {
    staticClass: "Viewer-uiHeader"
  }, [_c('div', {
    staticClass: "Viewer-uiButtons"
  }, [_c('viewer-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gallery),
      expression: "gallery"
    }],
    staticClass: "Viewer-button",
    attrs: {
      "icon": "grid",
      "title": "View gallery",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleGridButtonClick.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('viewer-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenfull.enabled && !_vm.screenfull.isFullscreen),
      expression: "screenfull.enabled && !screenfull.isFullscreen"
    }],
    staticClass: "Viewer-button",
    attrs: {
      "icon": "fullscreen",
      "title": "Fullscreen",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleFullscreenButtonClick.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('viewer-button', {
    staticClass: "Viewer-button",
    attrs: {
      "icon": "close",
      "title": "Close",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleCloseButtonClick.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "header",
    staticClass: "Viewer-header"
  }, [_c('div', {
    staticClass: "Viewer-breadcrumbsAndCounter"
  }, [(_vm.breadcrumbs) ? _c('breadcrumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.shiftUiHeader),
      expression: "!shiftUiHeader"
    }],
    staticClass: "Viewer-breadcrumbs c-grey-xlt2",
    attrs: {
      "items": _vm.breadcrumbs,
      "trailing-caret": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.shiftUiHeader),
      expression: "!shiftUiHeader"
    }],
    staticClass: "Viewer-counter Viewer-headerCounter t-mono-xs c-grey-xlt2"
  }, [_vm._v("\n                  " + _vm._s(_vm.index + 1) + " OF " + _vm._s(_vm.items.length) + "\n                ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "Viewer-uiContent"
  }), _vm._v(" "), _c('div', {
    staticClass: "Viewer-uiFooter"
  }, [(_vm.imageData[_vm.index]) ? _c('div', {
    staticClass: "Viewer-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shiftUiHeader),
      expression: "shiftUiHeader"
    }],
    staticClass: "Viewer-counter Viewer-footerCounter t-mono-xs c-grey-xlt2"
  }, [_vm._v("\n                " + _vm._s(_vm.index + 1) + " OF " + _vm._s(_vm.items.length) + "\n              ")]), _vm._v(" "), (_vm.imageData[_vm.index].caption) ? _c('markdown', {
    staticClass: "Viewer-caption t-text-sm c-grey-xlt2",
    attrs: {
      "content": _vm.imageData[_vm.index].caption
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imageData[_vm.index].filename) ? _c('p', {
    staticClass: "Viewer-filename t-mono-xxs c-grey-xlt2",
    domProps: {
      "innerHTML": _vm._s(_vm.removeExtension(_vm.imageData[_vm.index].filename))
    }
  }) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "Viewer-slider"
  }, [_c('div', {
    staticClass: "Viewer-sliderHeader"
  }), _vm._v(" "), _c('div', {
    ref: "slider",
    staticClass: "Viewer-sliderContent"
  }, [_c('div', {
    staticClass: "Viewer-prevNextButtons"
  }, [_c('transition-group', {
    attrs: {
      "name": "Viewer-prevNextButtons-"
    }
  }, [_c('viewer-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUi && _vm.showPreviousButton),
      expression: "showUi && showPreviousButton"
    }],
    key: "viewerPreviousButton",
    staticClass: "Viewer-button Viewer-previousButton",
    attrs: {
      "icon": "arrow-left",
      "title": "Previous image"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.previous.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('viewer-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUi && _vm.showNextButton),
      expression: "showUi && showNextButton"
    }],
    key: "viewerNextButton",
    staticClass: "Viewer-button Viewer-nextButton",
    attrs: {
      "icon": "arrow-right",
      "title": "Next image"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.next.apply(null, arguments)
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "Viewer-item"
    }, [_c('div', {
      staticClass: "Viewer-image"
    }, [_c('viewer-image', {
      staticClass: "Viewer-imageImage",
      attrs: {
        "smugmug": item,
        "load": _vm.loadImage(index)
      },
      on: {
        "dataLoaded": function($event) {
          return _vm.handleImageDataLoaded(index, $event)
        }
      }
    })], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "Viewer-sliderFooter"
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40f7d791"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Viewer.vue
// module id = 759
// module chunks = 1474